export const LIFE_INSURANCE = 'LIFE_INSURANCE';
export const VISION_SERVICES_PLAN = 'VISION_SERVICES_PLAN';
export const RETIREMENT_UNIVERSITY = 'RETIREMENT_UNIVERSITY';
export const RETIREMENT_EMPLOYEE = 'RETIREMENT_EMPLOYEE';
export const DISABILITY_INSURANCE = 'DISABILITY_INSURANCE';

export const PENSION_CHOICE =  'PENSION_CHOICE';
export const SAVINGS_CHOICE = 'SAVINGS_CHOICE';

export const CORE = 'CORE';
export const HEALTH_NET_BLUE_AND_GOLD = 'HEALTH_NET_BLUE_AND_GOLD';
export const KAISER_PERMANENTE = 'KAISER_PERMANENTE';
export const UC_CARE = 'UC_CARE';
export const UC_HEALTH_SAVINGS_PLAN = 'UC_HEALTH_SAVINGS_PLAN';
export const OPT_OUT_OF_MEDICAL = 'OPT_OUT_OF_MEDICAL';

export const SELF = 'SELF';
export const UC = 'UC';
export const UA = 'UA';
export const UCA = 'UCA';

export const DELTA_DENTAL_PPO = 'DELTA_DENTAL_PPO';
export const DELTACARE_USA = 'DELTACARE_USA';
export const OPT_OUT_OF_DENTAL = 'OPT_OUT_OF_DENTAL';

export const ON_OR_AFTER_JULY_1_2016 = 'ON_OR_AFTER_JULY_1_2016';
export const BETWEEN_JULY_1_2013_AND_JUNE_30_2016 = 'BETWEEN_JULY_1_2013_AND_JUNE_30_2016';
export const BEFORE_JULY_1_2013 = 'BEFORE_JULY_1_2013';

export const STAFF_OTHER_ACADEMIC_APPOINTEE = 'STAFF_OTHER_ACADEMIC_APPOINTEE';
export const DESIGNATED_FACULTY = 'DESIGNATED_FACULTY';

export const YES = 'YES';
export const NO = 'NO';

export const options_pensionChoice = [
  {
    name: 'Pension Choice',
    value: PENSION_CHOICE,
  },
  {
    name: 'Savings Choice',
    value: SAVINGS_CHOICE
  }
];

export const options_pensionChoiceElig = [
  {
    name: 'Staff/Other Academic Appointee',
    value: STAFF_OTHER_ACADEMIC_APPOINTEE,
  },
  {
    name: 'Designated Faculty',
    value: DESIGNATED_FACULTY
  }
];

export const options_medicalPlan = [
  {
    name: 'Core',
    value: CORE
  },
  {
    name: 'UC Blue & Gold HMO',
    value: HEALTH_NET_BLUE_AND_GOLD
  },
  {
    name: 'Kaiser Permanente HMO',
    value: KAISER_PERMANENTE
  },
  {
    name: 'UC Care',
    value: UC_CARE
  },
  {
    name: 'UC Health Savings Plan',
    value: UC_HEALTH_SAVINGS_PLAN
  },
  {
    name: 'Opt Out of Medical',
    value: OPT_OUT_OF_MEDICAL
  },
];

export const options_medicalCov = [
  {
    name: 'Just myself',
    value: SELF
  },
  {
    name: 'Myself plus child(ren)',
    value: UC
  },
  {
    name: 'Myself plus an adult',
    value: UA
  },
  {
    name: 'Myself plus an adult and child(ren)',
    value: UCA
  },
];
export const options_dentalPlan = [
  {
    name: 'Delta Dental PPO',
    value: DELTA_DENTAL_PPO
  },
  {
    name: 'DeltaCare USA',
    value: DELTACARE_USA
  },
  {
    name: 'Opt Out of Dental',
    value: OPT_OUT_OF_DENTAL
  },
];
export const options_denCov = [
  {
    name: 'Just myself',
    value: SELF
  },
  {
    name: 'Myself plus child(ren)',
    value: UC
  },
  {
    name: 'Myself plus an adult',
    value: UA
  },
  {
    name: 'Myself plus an adult and child(ren)',
    value: UCA
  },
];
export const options_hired_date_tier = [
  {
    name: 'On or after July 1, 2016',
    value: ON_OR_AFTER_JULY_1_2016
  },
  {
    name: 'Between July 1, 2013 and June 30, 2016',
    value: BETWEEN_JULY_1_2013_AND_JUNE_30_2016
  },
  {
    name: 'Before July 1, 2013',
    value: BEFORE_JULY_1_2013
  },
];
export const buttons_rehired = [
  {value: YES, id: 'rehired-yes', label: 'Yes'},
  {value: NO, id: 'rehired-no', label: 'No'}
];
export const buttons_hired_before_date = [
  {value: YES, id: 'rehired-before-yes', label: 'Yes'},
  {value: NO, id: 'rehired-before-no', label: 'No'}
];


